(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("moment"), require("Axios"), require("Popper"));
	else if(typeof define === 'function' && define.amd)
		define(["moment", "Axios", "Popper"], factory);
	else if(typeof exports === 'object')
		exports["VueInterface"] = factory(require("moment"), require("Axios"), require("Popper"));
	else
		root["VueInterface"] = factory(root["moment"], root["Axios"], root["Popper"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE_c32d__, __WEBPACK_EXTERNAL_MODULE_cebe__, __WEBPACK_EXTERNAL_MODULE_dbbc__) {
return 